(Drupal => {
  const ENTER_KEY_CODE = 'Enter';
  const SPACE_KEY_CODE = ' ';
  const DOWN_ARROW_KEY_CODE = 'ArrowDown';
  const UP_ARROW_KEY_CODE = 'ArrowUp';
  const ESCAPE_KEY_CODE = 'Escape';

  Drupal.behaviors.kafSearchSelect = {
    listItemIds: [],
    focusNextListItem: direction => {
      const activeElementId = document.activeElement.id;
      if (activeElementId === 'dropdown__selected') {
        document.querySelector(`#${Drupal.behaviors.kafSearchSelect.listItemIds[0]}`).focus();
      } else {
        const currentActiveElementIndex =
          Drupal.behaviors.kafSearchSelect.listItemIds.indexOf(activeElementId);
        if (direction === DOWN_ARROW_KEY_CODE) {
          const currentActiveElementIsNotLastItem =
            currentActiveElementIndex < Drupal.behaviors.kafSearchSelect.listItemIds.length - 1;
          if (currentActiveElementIsNotLastItem) {
            const nextListItemId =
              Drupal.behaviors.kafSearchSelect.listItemIds[currentActiveElementIndex + 1];
            document.querySelector(`#${nextListItemId}`).focus();
          }
        } else if (direction === UP_ARROW_KEY_CODE) {
          const currentActiveElementIsNotFirstItem = currentActiveElementIndex > 0;
          if (currentActiveElementIsNotFirstItem) {
            const nextListItemId =
              Drupal.behaviors.kafSearchSelect.listItemIds[currentActiveElementIndex - 1];
            document.querySelector(`#${nextListItemId}`).focus();
          }
        }
      }
    },

    buildSelectList: () => {
      let selection = '';
      const path = window.location.pathname;

      switch (true) {
        case path.startsWith('/recipes'):
          selection = '2';
          break;
        case path.startsWith('/blog'):
          selection = '4';
          break;

        default:
          selection = '0';
          break;
      }

      let x = document.getElementsByClassName('select--container');
      if (!x) return;
      let l = x.length;

      for (let i = 0; i < l; i++) {
        let selElmnt = x[i].getElementsByTagName('select')[0];
        let ll = selElmnt.length;
        selElmnt.selectedIndex = selection;
        let a = document.createElement('DIV');
        a.setAttribute('aria-expanded', 'false');
        a.setAttribute('aria-haspopup', 'listbox');
        a.setAttribute('class', 'select-selected');
        a.setAttribute('tabindex', "0");
        a.setAttribute('id', 'dropdown__selected');
        a.setAttribute('aria-label', 'select type of pages to search for');
        a.setAttribute('aria-controls', 'search__overlay--listbox-index-types');
        a.setAttribute('role', 'combobox');
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);
        let b = document.createElement('DIV');
        b.setAttribute('class', 'select-items select-hide');
        b.setAttribute('role', 'listbox');
        b.setAttribute('id', 'search__overlay--listbox-index-types');
        b.setAttribute('tabindex', "-1");
        for (let j = 1; j < ll; j++) {
          let c = document.createElement('DIV');
          c.innerHTML = selElmnt.options[j].innerHTML;
          c.setAttribute('data', selElmnt.options[j].value);
          c.setAttribute('role', 'option');
          c.setAttribute('class', 'select-item');
          c.setAttribute('tabindex', 0);
          c.setAttribute('id', `option-${j}`);
          c.addEventListener('click', function (e) {
            let s = this.parentNode.parentNode.getElementsByTagName('select')[0];
            let sl = s.length;
            let h = this.parentNode.previousSibling;
            for (let i = 0; i < sl; i++) {
              if (s.options[i].innerHTML == this.innerHTML) {
                s.selectedIndex = i;
                h.innerHTML = this.innerHTML;
                let y = this.parentNode.getElementsByClassName('same-as-selected');
                let yl = y.length;
                for (let k = 0; k < yl; k++) {
                  y[k].classList.remove('same-as-selected');
                }
                this.setAttribute('class', 'same-as-selected select-item');
                break;
              }
            }
            h.click();
          });

          c.addEventListener('keydown', function (e) {
            switch (e.key) {
              case ENTER_KEY_CODE:
              case SPACE_KEY_CODE:
                let activeElement = document.querySelector(`#${document.activeElement.id}`);
                Drupal.behaviors.kafSearchSelect.closeAllSelect(
                  activeElement.parentNode.parentNode.children[1]
                );
                let selectItems = document.querySelector('.select-items');
                let selectSelected = document.querySelector('.select-selected');
                let selectContainer = document.querySelector('.select--container');
                let ariaExpanded =
                  selectSelected.getAttribute('aria-expanded') === 'false' ? 'true' : 'false';
                selectSelected.setAttribute('aria-expanded', ariaExpanded);
                selectItems.classList.toggle('select-hide');
                selectSelected.classList.toggle('select-arrow-active');
                selectContainer.classList.toggle('active');
                let s = this.parentNode.parentNode.getElementsByTagName('select')[0];
                let sl = s.length;
                let h = this.parentNode.previousSibling;
                for (let i = 0; i < sl; i++) {
                  if (s.options[i].innerHTML == this.innerHTML) {
                    s.selectedIndex = i;
                    h.innerHTML = this.innerHTML;
                    let y = this.parentNode.getElementsByClassName('same-as-selected');
                    let yl = y.length;
                    for (let k = 0; k < yl; k++) {
                      y[k].classList.remove('same-as-selected');
                    }
                    this.setAttribute('class', 'same-as-selected select-item');
                    break;
                  }
                }
                // Set focus to controller after selection has been made.
                e.target.parentNode.parentNode.children[1].focus();
                return;

              case DOWN_ARROW_KEY_CODE:
                Drupal.behaviors.kafSearchSelect.focusNextListItem(DOWN_ARROW_KEY_CODE);
                return;

              case UP_ARROW_KEY_CODE:
                Drupal.behaviors.kafSearchSelect.focusNextListItem(UP_ARROW_KEY_CODE);
                return;

              case ESCAPE_KEY_CODE:
                Drupal.behaviors.kafSearchSelect.closeAllSelect(this);
                return;

              default:
                return;
            }
          });
          b.appendChild(c);
        }
        x[i].appendChild(b);

        a.addEventListener('click', function (e) {
          e.stopPropagation();
          Drupal.behaviors.kafSearchSelect.closeAllSelect(this);
          this.nextSibling.classList.toggle('select-hide');
          let ariaExpanded =
            this.getAttribute('aria-expanded') === 'false' ? 'true' : 'false';
          this.setAttribute('aria-expanded', ariaExpanded);
          this.classList.toggle('select-arrow-active');
          this.parentNode.classList.toggle('active');
        });

        a.addEventListener('keydown', function (e) {
          switch (e.key) {
            case ENTER_KEY_CODE:
            case SPACE_KEY_CODE:
              Drupal.behaviors.kafSearchSelect.closeAllSelect(this);
              this.nextSibling.classList.toggle('select-hide');
              let ariaExpanded =
                this.getAttribute('aria-expanded') === 'false' ? 'true' : 'false';
              this.setAttribute('aria-expanded', ariaExpanded);
              this.classList.toggle('select-arrow-active');
              this.parentNode.classList.toggle('active');
              return;

            case DOWN_ARROW_KEY_CODE:
              Drupal.behaviors.kafSearchSelect.focusNextListItem(DOWN_ARROW_KEY_CODE);
              return;

            case UP_ARROW_KEY_CODE:
              Drupal.behaviors.kafSearchSelect.focusNextListItem(UP_ARROW_KEY_CODE);
              return;

            case ESCAPE_KEY_CODE:
              Drupal.behaviors.kafSearchSelect.closeAllSelect(this);
              return;

            default:
              return;
          }
        });

        document
          .querySelectorAll('.search__overlay--inner-container .select-item')
          .forEach(item => Drupal.behaviors.kafSearchSelect.listItemIds.push(item.id));
      }
    },

    closeAllSelect: elmnt => {
      const arrNo = [];
      let x = document.getElementsByClassName('select-items');
      let y = document.getElementsByClassName('select-selected');
      let xl = x.length;
      let yl = y.length;
      for (let i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
          arrNo.push(i);
        } else {
          y[i].classList.remove('select-arrow-active');
          y[i].parentNode.classList.remove('active');
        }
      }
      for (let i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
          x[i].classList.add('select-hide');
        }
      }
    },
    attach: context => {
      if (context !== document) {
        return;
      }

      if (Drupal.behaviors.kafSearchSelect.initialized) {
        return;
      }

      Drupal.behaviors.kafSearchSelect.buildSelectList();

      document.addEventListener('click', Drupal.behaviors.kafSearchSelect.closeAllSelect);

      Drupal.behaviors.kafSearchSelect.initialized = true;
    },

    initialized: false,
  };
})(Drupal);
